import { Routes, Route } from 'react-router-dom';
import AppShell from '@/components/AppShell';
import RequireAuth from '@/components/RequireAuth';
import { AuthProvider } from '@/lib/auth-context';
import Dashboard from '@/pages/Dashboard';
import DomainsPage from '@/pages/Domains';
import DomainDetail from '@/pages/DomainDetail';
import GuidesPage from '@/pages/Guides';
import GuideViewer from '@/pages/GuideViewer';
import GuideNew from '@/pages/GuideNew';
import GuideEdit from '@/pages/GuideEdit';
import Checklists from '@/pages/Checklists';
import ChecklistTemplates from '@/pages/ChecklistTemplates';
import ChecklistTemplateDetail from '@/pages/ChecklistTemplateDetail';
import ChecklistTemplateEdit from '@/pages/ChecklistTemplateEdit';
import ChecklistTemplateNew from '@/pages/ChecklistTemplateNew';
import ChecklistRunPage from '@/pages/ChecklistRunPage';
import Logs from '@/pages/Logs';
import LogDetail from '@/pages/LogDetail';
import Photos from '@/pages/Photos';
import Equipment from '@/pages/Equipment';
import EquipmentDetail from '@/pages/EquipmentDetail';
import Inventory from '@/pages/Inventory';
import Projects from '@/pages/Projects';
import ProjectDetail from '@/pages/ProjectDetail';
import Vendors from '@/pages/Vendors';
import References from '@/pages/References';
import Settings from '@/pages/Settings';
import SignIn from '@/pages/auth/SignIn';
import Register from '@/pages/auth/Register';
import Forgot from '@/pages/auth/Forgot';
import Reset from '@/pages/auth/Reset';
import AcceptInvite from '@/pages/auth/AcceptInvite';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public auth surface — outside AppShell + RequireAuth so
            visitors can reach sign-in / register without being kicked
            back to themselves. */}
        <Route path="/auth/sign-in" element={<SignIn />} />
        <Route path="/auth/register" element={<Register />} />
        <Route path="/auth/forgot" element={<Forgot />} />
        <Route path="/auth/reset/:token" element={<Reset />} />
        <Route path="/auth/accept-invite/:token" element={<AcceptInvite />} />

        {/* Authenticated app. */}
        <Route element={<RequireAuth />}>
          <Route element={<AppShell />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/domains" element={<DomainsPage />} />
            <Route path="/domains/:slug" element={<DomainDetail />} />
            <Route path="/guides" element={<GuidesPage />} />
            <Route path="/guides/new" element={<GuideNew />} />
            <Route path="/guides/:idOrSlug/edit" element={<GuideEdit />} />
            <Route path="/guides/:slug" element={<GuideViewer />} />
            <Route path="/checklists" element={<Checklists />} />
            <Route path="/checklists/templates" element={<ChecklistTemplates />} />
            <Route path="/checklists/templates/new" element={<ChecklistTemplateNew />} />
            <Route path="/checklists/templates/:idOrSlug/edit" element={<ChecklistTemplateEdit />} />
            <Route path="/checklists/templates/:idOrSlug" element={<ChecklistTemplateDetail />} />
            <Route path="/checklists/runs/:id" element={<ChecklistRunPage />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/logs/:id" element={<LogDetail />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/equipment" element={<Equipment />} />
            <Route path="/equipment/:id" element={<EquipmentDetail />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/references" element={<References />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <div className="space-y-2">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="text-muted-foreground">This route doesn't exist yet.</p>
    </div>
  );
}
